const myModal = {
    yes: "Confirm",
    no: "Cancel",
};

export default myModal;
